import { render, staticRenderFns } from "./UploadAlert.vue?vue&type=template&id=035ce9bd&"
import script from "./UploadAlert.vue?vue&type=script&lang=js&"
export * from "./UploadAlert.vue?vue&type=script&lang=js&"
import style0 from "./UploadAlert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports